module.exports = __webpack_public_path__ + "media/images/flags/td-a03c26ba332af2f3e1637e3d9e1f0d82.svg";